<template>
    <div class="container">
        <div class="row mt-5">
            <div class="col-12">
                <h4>{{ $lang('Domyślny konsultant') }}</h4>
                <div class="form-group">
                    <select id="main_consultant" class="form-control" v-model="e_main">
                        <option v-for="consultant in consultants" :value="consultant.id">
                            {{ consultant.name + ' ' + consultant.surname }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-12 mt-4" v-if="e_modules.length > 0">
                <h4>{{ $lang('Domyślny konsultant wg modułu') }}</h4>

                <table class="table simple-table table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">{{ $lang('Moduł') }}</th>
                        <th scope="col">{{ $lang('Osoba') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(module, index) in e_modules">
                        <td :data-title="$lang('Moduł')">{{ module.name }}</td>
                        <td :data-title="$lang('Osoba')">
                            <div class="d-flex">
                                <div style="width: 90%; margin-right: 5px;">
                                    <div class="form-group mb-0">
                                        <select :id="'module_' + module.id + 'consultant'" class="form-control"
                                                v-model="e_modules[index].consultant_id">
                                            <option v-for="consultant in consultants" :value="consultant.id">
                                                {{ consultant.name + ' ' + consultant.surname }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <a v-if="e_modules[index].consultant_id !== null" href="#"
                                       :title="$lang('Usuń')"
                                       @click.prevent="e_modules[index].consultant_id = null;">
                                        <i class="fa fa-trash"/>
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 mt-5">
                <button id="config-save" @click.prevent="save()" type="button" class="btn btn-primary pull-right">
                    {{ $lang('Zapisz') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "library-consultants",
    mixins: [ShowNotification],
    props: {
        modules: {
            type: Array,
            required: true
        },
        consultants: {
            type: Array,
            required: true
        },
        mainConsultant: {
            type: Number,
        },
        saveUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            e_main: null,
            e_modules: [],
            e_mailing: []
        }
    },
    methods: {
        save() {
            let self = this;
            axios.post(this.saveUrl, {
                     main: this.e_main,
                     modules: this.e_modules.filter(x => x.consultant_id !== null)
            })
                 .then(function (response) {
                     self.showNotification('success', self.$lang('Zapisano!'));
                 })
                 .catch((error) => {
                     self.showNotification('error', self.$lang('Wystąpił błąd przy zapisie!'));
                     console.log(error);
                 });
        }
    },
    created() {
        if (this.mainConsultant && this.mainConsultant > 0) {
            this.e_main = this.mainConsultant;
        }

        this.e_modules = this.modules;
    }
}
</script>
